export default __webpack_public_path__ + "static/media/Adsz_tasarm_2.399ee0ad.png";